module.exports = __webpack_public_path__ + "img/numeralia_home4.628813c3.svg";